import { appHandler } from '@blaze-cms/core-ui';
import { EXPIRED_COOKIE, REFRESH_KEY } from '../constants';

const handleLogout = async client => {
  const app = appHandler.getApp();
  if (app) {
    await app.events.emitAsync('package:core-auth-ui:logout');
    await app.openQueryChecker.checkOpenQueries(true);
  }

  document.cookie = EXPIRED_COOKIE;
  window.localStorage.removeItem(REFRESH_KEY);
  return client.clearStore();
};

export default handleLogout;
